import React, { useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Popper, ClickAwayListener } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const TenderAwardTable = ({ tenders, activeTab, isLoading }) => {
  const navigate = useNavigate();
  
  const handleCheck = (tenderId) => {
    navigate(`/dashboard/${tenderId}`);
  };

  const columns = [
    // { field: "tenderId", headerName: "Tender ID", width: 200, headerAlign: "center", },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() => handleCheck(params.row.tenderId)}
        >
          {params.row.title}
        </span>
      ),
    },
    {
      field: "type",
      headerName: "Tender Type",
      flex: 1,
      renderCell: (params) =>
        params.row.type
          ? params.row.type.charAt(0).toUpperCase() +
            params.row.type.slice(1).toLowerCase()
          : "",
    },
    {
      field: "tenderPublishDate",
      headerName: "Tender Publish Date",
      flex: 1,
    },
    {
      field: "bidSubmissionEndDate",
      headerName: "Bid Close Date",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Tender Status",
      flex: 1,
      renderCell: (params) => 
          <span style={{
            background: "#0381F3",
            borderRadius: "15px",
            padding: "5px 15px",
            fontWeight: 600,
          }}>
            Awarded
          </span>
    },
    (activeTab !== "AWARDED" &&
    {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => (
            <Button
              className="btn-contained"
              sx={{
                margin: "0 !important",
                fontSize: "12px",
                px: 9,
                width: "0 !important",
              }}
              onClick={() => navigate(`/dashboard/view-bid-data/${params.row.tenderId}`)}
            >
              Award Bid
            </Button>
        ),
      }),
  ].filter(Boolean);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  const rows =
    tenders &&
    tenders.map((tender) => ({
      ...tender,
      tenderPublishDate: formatDate(tender.tenderPublishDate),
      bidSubmissionStartDate: formatDateTime(tender.bidSubmissionStartDate),
      bidSubmissionEndDate: formatDateTime(tender.bidSubmissionEndDate),
    }));

  return (
    <Box sx={{ width: "100%", minHeight: "400px" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.tenderId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />
    </Box>
  );
};

export default TenderAwardTable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}